"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function FolderOutlineIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M20.781,5.708H10.394a.371.371,0,0,1-.261-.108l-1.5-1.5a2.051,2.051,0,0,0-1.462-.607H3.219A2.071,2.071,0,0,0,1.15,5.562V18.438a2.071,2.071,0,0,0,2.069,2.068H20.781a2.071,2.071,0,0,0,2.069-2.068V7.776A2.071,2.071,0,0,0,20.781,5.708ZM3.219,5.193H7.171a.366.366,0,0,1,.261.11l1.5,1.5a2.055,2.055,0,0,0,1.462.605H20.781a.37.37,0,0,1,.369.369v2.377H2.85V5.562A.37.37,0,0,1,3.219,5.193ZM20.781,18.807H3.219a.37.37,0,0,1-.369-.369V11.853h18.3v6.585A.37.37,0,0,1,20.781,18.807Z" })));
}
exports.default = FolderOutlineIcon;
